import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect, useLocation } from 'react-router-dom';
import Home from './pages/home';
import Intro from './pages/intro';
import AdminLogin from './pages/AdminLogin';
import AdminEditor from './pages/AdminEditor';
import AdminTours from './pages/AdminTours';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import PanoContextContainer from './contexts/PanoContextContainer.js';
import PageTransition from './pages/components/pageTransition';

function App() {
  const location = useLocation();

  // Check if current route is an admin page
  const isAdminRoute = location.pathname.startsWith('/admin');

  if (isAdminRoute) {
    return (
      <Switch location={location}>
        <Route exact path="/admin/login" component={AdminLogin} />
        <Route exact path="/admin/tours" component={AdminTours} />
        <Route exact path="/admin/editor/:tourId" component={AdminEditor} />
        <Route path="/admin" render={() => <Redirect to="/admin/tours" />} />
      </Switch>
    );
  }

  return (
    <>
      <PageTransition>
        <Switch location={location}>
          <Route
            exact
            path="/"
            render={(props) => {
              const queryParams = new URLSearchParams(props.location.search);
              if (queryParams.has('tour')) {
                return <Redirect to={`/index?tour=${queryParams.get('tour')}`} />;
              }
              return <Intro {...props} />;
            }}
          />
          <Route exact path="/index" render={() => {
            return (
              <PanoContextContainer>
                <Home />
              </PanoContextContainer>
            )
          }} />
        </Switch>
      </PageTransition>
    </>
  );
}

const AppWithRouter = () => (
  <Router>
    <App />
  </Router>
);

export default AppWithRouter;
